import Swal from 'sweetalert2'
import { defineNuxtPlugin } from '#app'

export default defineNuxtPlugin(() => {
  return {
    provide: {
      notify: ({ ...args }) => {
        Swal.fire({
          toast: args.toast,
          iconHtml: args.icon ? `<img src="${args.icon}">` : '',
          position: args?.position || 'center',
          title: args.title,
          text: args.text,
          html: args.html,
          showCloseButton: args.showCloseButton !== false,
          showConfirmButton: !!args.confirmButtonText,
          showCancelButton: !!args.cancelButtonText,
          confirmButtonText: args.confirmButtonText,
          cancelButtonText: args.cancelButtonText,
          buttonsStyling: false,
          timer: args.timer,
          customClass: {
            ...args.customClass
          }
        }).then((result) => {
          /* Read more about isConfirmed, isDenied below */
          if (args?.confirmButtonFunc && result.isConfirmed) {
            args.confirmButtonFunc()
          } else if (args?.cancelButtonFunc && result.dismiss === Swal.DismissReason.cancel) {
            args.cancelButtonFunc()
          } else if (args?.closePopupFunc && (Swal.DismissReason.close || result.isDismissed)) {
            args.closePopupFunc()
          }
        })
      }
    }
  }
})
